module.exports = "/static/assets/11bf76b0779a57b30e614213f43eb983.png";